import { render, staticRenderFns } from "./InfiniteBiScroll.vue?vue&type=template&id=2ded814f&scoped=true"
import script from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InfiniteBiScroll.vue?vue&type=style&index=0&id=2ded814f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded814f",
  null
  
)

export default component.exports